export default __webpack_public_path__ + "static/media/fechar.73c28317.svg";